import * as React from 'react';

import useAuthenticatedRoutesContainer from 'AuthenticatedRoutesContainer/useAuthenticatedRoutesContainer';
import EmptyView from 'common/components/core/EmptyView/EmptyView';
import GlobalLoader from 'common/components/GlobalLoader/GlobalLoader';
import SubscribedNotificationsProvider from 'common/components/SubscribedNotificationsContext/SubscribedNotificationsProvider';
import MyTasksProvider from 'common/components/withMyTasks/MyTasksProvider';
import SubscribedTasksProvider from 'common/components/withSubscribedTasks/SubscribedTasksProvider';
import Icons from 'common/icons';

import Motd from './Motd/Motd';
import TermsOfServiceAcceptanceDialog from './TermsOfServiceAcceptanceDialog/TermsOfServiceAcceptanceDialog';
import useTokenWatcher from './TokenWatcher/useTokenWatcher';

export type AuthenticatedRoutesContainerProps = { shouldLogin: boolean };

export default function AuthenticatedRoutesContainer({
  shouldLogin,
  children,
}: React.PropsWithChildren<AuthenticatedRoutesContainerProps>) {
  const { queryResult, shouldAcceptTerms, tosVersion, onAcceptTOS, showMotd, motd, acknowledgeMotd } =
    useAuthenticatedRoutesContainer({
      shouldLogin,
    });

  useTokenWatcher();

  if (queryResult.loading) {
    return <GlobalLoader />;
  }

  if (queryResult.error) {
    return (
      <EmptyView
        iconUrl={Icons.INFO}
        description="The page could not be displayed. Please try again."
        fullScreen={true}
      />
    );
  }

  const showAppContent = !shouldAcceptTerms && !showMotd;

  return (
    <SubscribedTasksProvider>
      <SubscribedNotificationsProvider>
        <MyTasksProvider>
          {shouldAcceptTerms && <TermsOfServiceAcceptanceDialog currentTos={tosVersion} acceptTerms={onAcceptTOS} />}

          {showMotd && motd && <Motd onAccept={acknowledgeMotd}>{motd}</Motd>}

          {showAppContent && children}
        </MyTasksProvider>
      </SubscribedNotificationsProvider>
    </SubscribedTasksProvider>
  );
}
